import { ChatBubble } from './types'

/**
 * B-Gini değerlendirme anketi daveti. Anket (Id=21) test bayilerine hedeflenmiştir; hedefleme,
 * tarih aralığı ve "zaten cevapladı" kontrolü `survey/list` servisinde yapılır. Widget yalnız
 * listede bu anketin sorusu var mı diye bakar — yoksa davet hiç görünmez.
 */
export const SURVEY_INVITE_ID = 21

export const SURVEY_INVITE_PATH = `/survey?Id=${SURVEY_INVITE_ID}`

/** Davetin son anı (tarayıcı saati): 01.11.2026 00:00 ve sonrasında davet gösterilmez. */
export const SURVEY_INVITE_UNTIL = new Date(2026, 10, 1, 0, 0, 0)

export const isSurveyInviteActive = (now: Date = new Date()) => now.getTime() < SURVEY_INVITE_UNTIL.getTime()

const SURVEY_INVITE_TEXT =
  'Görüşleriniz benim için çok değerli!\nKısa değerlendirme anketine katılarak gelişimime katkı sağlayın.'

export const surveyInviteBubble = (id: number): ChatBubble => ({
  id,
  role: 'bot',
  text: SURVEY_INVITE_TEXT,
  welcome: 'surveyInvite',
  navigationActions: [{ label: 'Ankete katıl', path: SURVEY_INVITE_PATH }],
})

/** `survey/list` yanıtında davet edilen anketin en az bir sorusu var mı? Casing garanti değil. */
export function hasPendingSurvey(questions: unknown, surveyId: number = SURVEY_INVITE_ID): boolean {
  if (!Array.isArray(questions)) return false
  return questions.some(q => {
    if (!q || typeof q !== 'object') return false
    const row = q as Record<string, unknown>
    return Number(row.SurveyId ?? row.surveyId) === surveyId
  })
}

/**
 * Sohbet YALNIZ yerel karşılama balonundan ibaretse
 * daveti hemen altına ekler; aksi hâlde listeyi aynen döner. Böylece taban karşılama, ilk temas
 * tanıtımı ve "Yeni Sohbet" aynı kuralla davet alır; devam eden sohbetlerin araya girilmez.
 */
export function withSurveyInvite(messages: ChatBubble[], nextId: () => number): ChatBubble[] {
  if (messages.length !== 1) return messages
  const [greeting] = messages
  if (greeting.welcome !== 'greeting') return messages
  return [greeting, surveyInviteBubble(nextId())]
}

/** Ana sayfadaki anket baloncuğu bu sekmede kapatıldı mı / ankete gidildi mi. */
const SURVEY_NUDGE_SESSION_KEY = `INDEXPAZAR_CHATBOT_SURVEY_${SURVEY_INVITE_ID}_NUDGE_CLOSED`

export function isSurveyNudgeClosed(): boolean {
  // sessionStorage erişimi istisna atabilir (Safari özel mod); okunamazsa "kapatılmadı" sayılır.
  try {
    return window.sessionStorage.getItem(SURVEY_NUDGE_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function markSurveyNudgeClosed() {
  try {
    window.sessionStorage.setItem(SURVEY_NUDGE_SESSION_KEY, '1')
  } catch {
    // Yazılamazsa baloncuk ana sayfaya her dönüşte yeniden çıkabilir; kırılma olmaz.
  }
}
